var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconDownload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9992 5.4502C12.441 5.4502 12.7992 5.80837 12.7992 6.2502V12.7039L15.214 10.5306C15.5425 10.235 16.0483 10.2616 16.3439 10.59C16.6394 10.9184 16.6128 11.4243 16.2844 11.7198L12.5344 15.0948C12.2301 15.3687 11.7683 15.3687 11.464 15.0948L7.71405 11.7198C7.38564 11.4243 7.35902 10.9184 7.65458 10.59C7.95015 10.2616 8.45598 10.235 8.78439 10.5306L11.1992 12.7039V6.2502C11.1992 5.80837 11.5574 5.4502 11.9992 5.4502ZM5.99922 14.5752C6.44105 14.5752 6.79922 14.9334 6.79922 15.3752V16.5002C6.79922 16.8868 7.11262 17.2002 7.49922 17.2002H16.4992C16.8858 17.2002 17.1992 16.8868 17.1992 16.5002V15.3752C17.1992 14.9334 17.5574 14.5752 17.9992 14.5752C18.441 14.5752 18.7992 14.9334 18.7992 15.3752V16.5002C18.7992 17.7705 17.7695 18.8002 16.4992 18.8002H7.49922C6.22896 18.8002 5.19922 17.7705 5.19922 16.5002V15.3752C5.19922 14.9334 5.55739 14.5752 5.99922 14.5752Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/iconDownload.24b23925b5708b1c04b37f2306ea9a92.svg";
export { ForwardRef as ReactComponent };